import { Transfer } from 'antd';

import { styled } from '@mui/material';

export const TransferStyled = styled(Transfer)`
  width: 100%;

  .ant-transfer-list {
    width: 50%;
    height: 50vh;
  }
`;
